export const defaultDashboardPageSize = 30;
export const maximumDashboardPageSize = 50;
